import Vue from "vue";

import Menu from "vue-material-design-icons/Menu.vue";
//https://materialdesignicons.com/
/* Side and bottom bar */
import Bell from "vue-material-design-icons/Bell.vue";
import Lock from "vue-material-design-icons/Lock.vue";
import Tractor from "vue-material-design-icons/Tractor.vue";
import BellOff from "vue-material-design-icons/BellOff.vue";
import Logout from "vue-material-design-icons/Logout.vue";
import LogoutVariant from "vue-material-design-icons/LogoutVariant.vue";
import Account from "vue-material-design-icons/Account.vue";
import AccountGroup from "vue-material-design-icons/AccountGroup.vue";
/* End */

/* Shared */
import SettingsOutline from "vue-material-design-icons/CogOutline.vue";
import SettingsSolid from "vue-material-design-icons/Cog.vue";
import CalendarClock from "vue-material-design-icons/CalendarClock.vue";
import MapMarker from "vue-material-design-icons/MapMarker.vue";

import Eye from "vue-material-design-icons/Eye.vue";
import EyeOff from "vue-material-design-icons/EyeOff.vue";

/*Files*/
import Excel from "vue-material-design-icons/FileExcel.vue";
import Pdf from "vue-material-design-icons/FilePdfBox.vue";
import Csv from "vue-material-design-icons/FileDelimited.vue";
/* End */

/* Monitoring */
import Water from "vue-material-design-icons/Water.vue";
import Numeric0Outline from "vue-material-design-icons/Numeric0BoxOutline";
import Gauge from "vue-material-design-icons/Gauge.vue";
import ClipboardCheckOutline from "vue-material-design-icons/ClipboardCheckOutline.vue";
import ChartAreaspline from "vue-material-design-icons/ChartAreaspline.vue";
import ChartBar from "vue-material-design-icons/ChartBar.vue";
import WeatherPartlycloudy from "vue-material-design-icons/WeatherPartlyCloudy.vue";

import Magnify from "vue-material-design-icons/Magnify.vue";
import MagnifyClose from "vue-material-design-icons/MagnifyClose.vue";
import Filter from "vue-material-design-icons/Filter.vue";
import FilterClear from "vue-material-design-icons/FilterRemove.vue";

import ArrowUp from "vue-material-design-icons/ArrowUp.vue";
import ArrowDown from "vue-material-design-icons/ArrowDown.vue";
import ArrowLeft from "vue-material-design-icons/ArrowLeft.vue";
import ArrowRight from "vue-material-design-icons/ArrowRight.vue";
import ArrowTopRight from "vue-material-design-icons/ArrowTopRight.vue";
import VerticalSwap from "vue-material-design-icons/SwapVertical.vue";

import PumpOn from "vue-material-design-icons/WaterPump.vue";

import SignalOff from "vue-material-design-icons/SignalOff.vue";
import Leaf from "vue-material-design-icons/Leaf.vue";
import Earth from "vue-material-design-icons/Earth.vue";

import HelpOutline from "vue-material-design-icons/HelpCircleOutline.vue";

// schedule
import Check from "vue-material-design-icons/Check.vue";
import SignalOneAlert from "vue-material-design-icons/NetworkStrength1Alert.vue";
import Play from "vue-material-design-icons/Play.vue";
import Stop from "vue-material-design-icons/Stop.vue";
import CalendarRemove from "vue-material-design-icons/CalendarRemove.vue";
import ClockOutline from "vue-material-design-icons/ClockOutline.vue";
import ClockAlertOutline from "vue-material-design-icons/ClockAlertOutline.vue";
import ProgressClock from "vue-material-design-icons/ProgressClock.vue";

/* End */

/* Registering */
import AccountBoxMultiple from "vue-material-design-icons/AccountBoxMultiple.vue";
import Sector from "vue-material-design-icons/Map.vue";
import SourceBranch from "vue-material-design-icons/SourceBranch.vue";
import CodeNotEqualVariant from "vue-material-design-icons/CodeNotEqualVariant.vue";
import CodeEqual from "vue-material-design-icons/CodeEqual.vue";
import CupWater from "vue-material-design-icons/CupWater.vue";
import CupOff from "vue-material-design-icons/CupOff.vue";
import WaterPercent from "vue-material-design-icons/WaterPercent.vue";
import BriefCase from "vue-material-design-icons/Briefcase.vue";
import ChartBubble from "vue-material-design-icons/ChartBubble.vue";
import Engine from "vue-material-design-icons/Engine.vue";
import DragHorizontal from "vue-material-design-icons/DragHorizontal";
import DragVertical from "vue-material-design-icons/DragVertical";
import DotsHorizontalCircle from "vue-material-design-icons/DotsHorizontalCircle.vue";
import DotsVerticalCircle from "vue-material-design-icons/DotsVerticalCircle.vue";
import Sprout from "vue-material-design-icons/Sprout.vue";
import CubeOutline from "vue-material-design-icons/CubeOutline.vue";
import BackupRestore from "vue-material-design-icons/BackupRestore.vue"
import Leak from "vue-material-design-icons/Leak.vue"
import Pump from "vue-material-design-icons/Pump.vue"
// /schedule
import Beaker from "vue-material-design-icons/BeakerOutline.vue";
import CalendarEdit from "vue-material-design-icons/CalendarEdit.vue";

// /sectors
import Flower from "vue-material-design-icons/Flower.vue";
import Note from "vue-material-design-icons/Note.vue";
import Calendar from "vue-material-design-icons/Calendar.vue";
import Texture from "vue-material-design-icons/Texture.vue";
/* End */

/* Configuring */
import AccessPoint from "vue-material-design-icons/AccessPoint.vue";
import Ethernet from "vue-material-design-icons/Ethernet.vue";
import Wifi from "vue-material-design-icons/Wifi.vue";
import Logs from "vue-material-design-icons/TableOfContents.vue";
import Power from "vue-material-design-icons/Power.vue";
import Toolbox from "vue-material-design-icons/ToolboxOutline.vue";
import InfoOutline from "vue-material-design-icons/InformationOutline.vue";
/* End */

/* Actions */
import Save from "vue-material-design-icons/ContentSave.vue";
import Close from "vue-material-design-icons/Close.vue";
import Printer from "vue-material-design-icons/Printer.vue";
import Plus from "vue-material-design-icons/Plus.vue";
import Delete from "vue-material-design-icons/Delete.vue";
import Pencil from "vue-material-design-icons/Pencil.vue";
import Update from "vue-material-design-icons/Update.vue";
import Sync from "vue-material-design-icons/Sync.vue";
import Vanish from "vue-material-design-icons/Vanish.vue";
import BlockHelper from "vue-material-design-icons/BlockHelper.vue";

import ChevronDoubleDown from "vue-material-design-icons/ChevronDoubleDown.vue";
import ChevronDoubleUp from "vue-material-design-icons/ChevronDoubleUp.vue";
/* End */

import Download from "vue-material-design-icons/Download.vue";
import Upload from "vue-material-design-icons/Upload.vue";

import Battery from "vue-material-design-icons/Battery.vue";
import BatteryOutline from "vue-material-design-icons/BatteryOutline.vue";

/* Weather */
import Cloudy from "vue-material-design-icons/WeatherCloudy.vue";
import Pouring from "vue-material-design-icons/WeatherPouring.vue";
import LightningRainy from "vue-material-design-icons/WeatherLightningRainy.vue";
import Snowflake from "vue-material-design-icons/Snowflake.vue";
import Night from "vue-material-design-icons/WeatherNight.vue";
import Sunny from "vue-material-design-icons/WeatherSunny.vue";
import Alert from "vue-material-design-icons/Alert.vue";
import AlertOutline from "vue-material-design-icons/AlertOutline.vue";
import Navigation from "vue-material-design-icons/Navigation.vue";
/* End */

/*Print icons */

/*-------- */

import contentCopy from "vue-material-design-icons/ContentCopy";

// 3v3 icons
Vue.component("logo-icon", require("./3v3logo").default);
Vue.component("vvv-icon", require("./3v3").default);
Vue.component("dir-icon", require("./3v3dir-icon").default);
Vue.component("eqp-icon", require("./3v3eqp-icon").default);
Vue.component("station-icon", require("./3v3station-icon").default);

Vue.component("menu-icon", Menu);

Vue.component("content-copy", contentCopy);

Vue.component("block-helper", BlockHelper);

// materialdesign icons
Vue.component("leak-icon",Leak)
Vue.component("settings-outline-icon", SettingsOutline);
Vue.component("settings-solid-icon", SettingsSolid);
Vue.component("code-not-equal-icon", CodeNotEqualVariant);
Vue.component("code-equal-icon", CodeEqual);
Vue.component("bell-icon", Bell);
Vue.component("lock-icon", Lock);
Vue.component("bell-off-icon", BellOff);
Vue.component("logout-icon", Logout);
Vue.component("logout-variant-icon", LogoutVariant);
Vue.component("active-user-icon", Account);
Vue.component("user-group-icon", AccountGroup);
Vue.component("texture-icon", Texture);
Vue.component("account-box-multiple-icon", AccountBoxMultiple);
Vue.component("source-branch-icon", SourceBranch);
Vue.component("sector-icon", Sector);
Vue.component("cup-water-icon", CupWater);
Vue.component("water-icon", Water);
Vue.component("water-percent-icon", WaterPercent);
Vue.component("numeric-zero-outline", Numeric0Outline);
Vue.component("battery-icon", Battery);
Vue.component("battery-outline-icon", BatteryOutline);
Vue.component("gauge-icon", Gauge);
Vue.component("map-marker-icon", MapMarker);
Vue.component("calendar-clock-icon", CalendarClock);
Vue.component("report-icon", ClipboardCheckOutline);
Vue.component("chart-icon", ChartAreaspline);
Vue.component("chart-bar", ChartBar);
Vue.component("weather-icon", WeatherPartlycloudy);
Vue.component("beaker-icon", Beaker);
Vue.component("briefcase-icon", BriefCase);
Vue.component("edited-agn-icon", CalendarEdit);
Vue.component("chart-bubble-icon", ChartBubble);
Vue.component("access-icon", AccessPoint);
Vue.component("ethernet-icon", Ethernet);
Vue.component("wifi-icon", Wifi);
Vue.component("logs-icon", Logs);
Vue.component("power-icon", Power);
Vue.component("toolbox-icon", Toolbox);
Vue.component("info-outline-icon", InfoOutline);
Vue.component("cup-off-icon", CupOff);
Vue.component("check-icon", Check);
Vue.component("signal-one-alert-icon", SignalOneAlert);
Vue.component("play-icon", Play);
Vue.component("stop-icon", Stop);
Vue.component("calendar-remove-icon", CalendarRemove);
Vue.component("clock-icon", ClockOutline);
Vue.component("clock-alert-icon", ClockAlertOutline);
Vue.component("progress-clock-icon", ProgressClock);
Vue.component("engine-icon", Engine);
Vue.component("eye-icon", Eye);
Vue.component("eye-off-icon", EyeOff);
Vue.component("drag-horizontal-icon", DragHorizontal);
Vue.component("drag-vertical-icon", DragVertical);
Vue.component("excel-icon", Excel);
Vue.component("pdf-icon", Pdf);
Vue.component("csv-icon", Csv);
Vue.component("dots-horizontal-circle-icon", DotsHorizontalCircle);
Vue.component("dots-vertical-circle-icon", DotsVerticalCircle);
Vue.component("printer-icon", Printer);
Vue.component("plus-icon", Plus);
Vue.component("delete-icon", Delete);
Vue.component("pencil-icon", Pencil);
Vue.component("save-icon", Save);
Vue.component("close-icon", Close);
Vue.component("update-icon", Update);
Vue.component("sync-icon", Sync);
Vue.component("vanish-icon", Vanish);
Vue.component("sprout-icon", Sprout);
Vue.component("cube-outline-icon", CubeOutline);
Vue.component("earth-icon", Earth);
Vue.component("signal-off-icon", SignalOff);
Vue.component("leaf-icon", Leaf);
Vue.component("tractor-icon", Tractor);
Vue.component("backup-restore-icon",BackupRestore)
Vue.component("chev-doub-down-icon", ChevronDoubleDown);
Vue.component("chev-doub-up-icon", ChevronDoubleUp);

Vue.component("flower-icon", Flower);
Vue.component("note-icon", Note);
Vue.component("calendar-icon", Calendar);

Vue.component("download-icon", Download);
Vue.component("upload-icon", Upload);

Vue.component("cloudy-icon", Cloudy);
Vue.component("pouring-icon", Pouring);
Vue.component("lightning-rainy-icon", LightningRainy);
Vue.component("snowflake-icon", Snowflake);
Vue.component("night-icon", Night);
Vue.component("sunny-icon", Sunny);
Vue.component("alert-icon", Alert);
Vue.component("alert-outline-icon", AlertOutline);
Vue.component("navigation-icon", Navigation);

Vue.component("help-icon", HelpOutline);

Vue.component("search-icon", Magnify);
Vue.component("stop-search-icon", MagnifyClose);
Vue.component("filter-icon", Filter);
Vue.component("clear-filter-icon", FilterClear);

Vue.component("arrow-up-icon", ArrowUp);
Vue.component("arrow-down-icon", ArrowDown);
Vue.component("arrow-right-icon", ArrowRight);
Vue.component("arrow-left-icon", ArrowLeft);
Vue.component("swap-vertical-icon", VerticalSwap);
Vue.component("arrow-top-right", ArrowTopRight);
Vue.component("pump-icon", Pump);
Vue.component("pump-on-icon", PumpOn);
Vue.component("pump-off-icon", require("./water-pump-off-by-Nick").default);
